// extracted by mini-css-extract-plugin
export default {"content":"lD-z"};